export const STATUS_HISTORY = {
  Owner: 'Em análise por uma pessoa especialista',
  Queue: 'Em fila de atendimento',
  Open: 'Abertura de chamado',
};
